// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__dB5JB","copy":"styles_copy__husX6","advertiserTooltip":"styles_advertiserTooltip__848ZN"};